module.exports = __webpack_public_path__ + "static/media/adela.5261244d.jpg";